

















import { Component, Vue } from "vue-property-decorator";

@Component
export default class GlobalFooter extends Vue {
  get thisYear(): number {
    return new Date().getFullYear();
  }
}
